import { Form, Input } from "formik-antd"
import { ValidateEmailInput } from "../../utils/validation"
import { Link } from "react-router-dom"

function EmailInput(props) {
  const validateEmail = (value) => {
    const loggedEmail = localStorage.getItem("loggedEmail")
    if (!props.disabled) {
      if (!props?.unique || loggedEmail !== value) {
        ValidateEmailInput(value, props?.unique, props?.errorMessage)
      } else {
        return (
          <>
            A user is already registered with this e-mail address. If you
            already have an account, please <Link to="/login">Login</Link>
          </>
        )
      }
    }
  }

  return (
    <Form.Item
      name={props.name}
      hasFeedback={props.hasFeedback}
      showValidateSuccess={props.showValidateSuccess}
      required={props.required}
      label={props.label}
      validate={(value) => validateEmail(value)}
    >
      <Input
        name={props.name}
        size="large"
        autoComplete="email"
        autoCorrect="off"
        autoCapitalize="none"
        placeholder={props.placeholder}
        required={props.required}
        onChange={(e) => {
          props.formik.setFieldValue(props.name, e.target.value.trim())
        }}
        disabled={props.disabled}
      />
    </Form.Item>
  )
}

export default EmailInput
